import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material"
import { TestData } from "graphql/types"

type AddAmbientConditionsProps = {
  data: TestData
  setData: (arg: TestData) => void
}

export const AddAmbientConditions = (props: AddAmbientConditionsProps) => {
  const { data, setData } = props

  // Konvertiere boolean zu string für RadioGroup, oder verwende leeren String für undefined
  const getRadioValue = () => {
    if (data.ambientConditions === true) return "true"
    if (data.ambientConditions === false) return "false"
    return ""
  }

  return (
    <RadioGroup
      row
      name="Ambient Conditions"
      value={getRadioValue()}
      onChange={(e) => {
        const newValue =
          e.target.value === "true" ? true : e.target.value === "false" ? false : undefined
        setData({ ...data, ambientConditions: newValue })
      }}
      sx={{ display: "flex", gap: 1, alignItems: "center" }}
    >
      <Typography sx={{ fontWeight: "bold" }}>
        Laborumgebungsbedingungen innerhalb akzeptabler Parameter: *
      </Typography>
      <FormControlLabel value="true" control={<Radio />} label="Ja" />
      <FormControlLabel value="false" control={<Radio />} label="Nein" />
    </RadioGroup>
  )
}
